import { render, staticRenderFns } from "./DashboardIssues.vue?vue&type=template&id=c671cd3c"
import script from "./DashboardIssues.vue?vue&type=script&lang=js"
export * from "./DashboardIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports